import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../constants/form'
import { FormModal } from '../../Form'

import {
  REQUEST_EDIT_DUE_DATE_MODAL_QA_NAME,
  REQUEST_EDIT_DUE_DATE_MODAL_SUBMIT_QA_NAME,
} from './RequestEditDueDateModal.constants'
import {
  getRequestEditDueDateSubmitPayload,
  getRequestEditDueDateValidationSchema,
  getRequestEditDueDateWithActionTypesValidationSchemaCheckNoChanges,
} from './RequestEditDueDateModal.utils'
import { RequestEditDueDateModalFields } from './RequestEditDueDateModalFields'

function RequestEditDueDateModal({
  Fields = RequestEditDueDateModalFields,
  initialValues,
  itemAction,
  validationSchema = getRequestEditDueDateValidationSchema,
  onSubmit,
  ...restProps
}) {
  const preparedValidationSchema = itemAction
    ? getRequestEditDueDateWithActionTypesValidationSchemaCheckNoChanges({
        initialValues,
        itemAction,
        validationSchema,
      })
    : validationSchema()

  function handleSubmit({ value, values }) {
    onSubmit({
      payload: value,
      values,
    })
  }

  return (
    <FormModal
      {...restProps}
      Fields={Fields}
      containerProps={{ qaName: REQUEST_EDIT_DUE_DATE_MODAL_QA_NAME }}
      formBodyProps={{
        ...FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION,
        submitQaName: REQUEST_EDIT_DUE_DATE_MODAL_SUBMIT_QA_NAME,
      }}
      formTitle='Modal.AddDeadlineTitleKey'
      getPayload={getRequestEditDueDateSubmitPayload}
      initialValues={initialValues}
      validationSchema={preparedValidationSchema}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestEditDueDateModal
